// Generated by purs version 0.13.0
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Red = (function () {
    function Red() {

    };
    Red.value = new Red();
    return Red;
})();
var Cyan = (function () {
    function Cyan() {

    };
    Cyan.value = new Cyan();
    return Cyan;
})();
var Yellow = (function () {
    function Yellow() {

    };
    Yellow.value = new Yellow();
    return Yellow;
})();
var Green = (function () {
    function Green() {

    };
    Green.value = new Green();
    return Green;
})();
var eqColor = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Red && y instanceof Red) {
            return true;
        };
        if (x instanceof Cyan && y instanceof Cyan) {
            return true;
        };
        if (x instanceof Yellow && y instanceof Yellow) {
            return true;
        };
        if (x instanceof Green && y instanceof Green) {
            return true;
        };
        return false;
    };
});
module.exports = {
    Red: Red,
    Cyan: Cyan,
    Yellow: Yellow,
    Green: Green,
    eqColor: eqColor
};
